export default "__VITE_ASSET__C1hn_zef__"